export default {
	// initiële state bij het starten van de app.
	// Evt defaults in opnemen
	ajaxCounter: 0,
	exception: null,
	errorMessage: "",
	aanvraag: {
		id: null,
		item: null,
		errors: null
	},
	project: {
		id: null,
		item: {
			sportinfrastructurenInDeBuurt: []
		},
		errors: null,
		infrastructuurErrors: null,
		isLoaded: false,
		isSaved: true
	},
	minimaleEisenPerDossier: {
		item: null,
		errors: null
	},
	minimaleEisenPerInfrastructuur: {
		item: null,
		errors: null,
		hasValidationErrors: null
	},
	bovenLokaliteitPerDossier: {
		item: null,
		errors: null
	},
	bovenLokaliteitPerInfrastructuur: {
		item: null,
		isLoaded: false,
		isLoading: false,
		errors: null,
		documenten: null,
		fileSessionStarted: false,
		hasValidationErrors: false
	},
	simulatiePerInfrastructuurModal: {
		item: null,
		isLoaded: false,
		isLoading: false,
		errors: null,
		documenten: null,
		fileSessionStarted: false
	},
	beoordelingscriteria: {
		item: null,
		errors: null
	},
	simulatieDossier: {
		item: {
			sportinfrastructurenInDeBuurt: []
		},
		isLoaded: false,
		isSaved: true
	},
	mijnDossier: null,
	schaduwDossier: { model: null, finishedLoading: false },
	infrastructuren: [],
	indienen: {
		dossierId: null,
		tabTitle: null,
		validatieStatussen: [],
		status: null,
		wijktTotaleFinancieringAfVanTotaleInvestering: null,
		isIndiendatumVerstreken: null,
		uitersteDatumIndienen: null
	},
	beads: [
		{
			"tab": 0,
			"status": 0,
			"titel": "Aanvraag"
		},
		{
			"tab": 1,
			"status": 0,
			"titel": "Project"
		},
		{
			"tab": 2,
			"status": 0,
			"titel": "Minimale Eisen (Algemeen)"
		},
		{
			"tab": 13,
			"status": 0,
			"titel": "Financieel"
		},
		{
			"tab": 3,
			"status": 0,
			"titel": "Bovenlokaliteit (Algemeen)"
		},
		{
			"tab": 4,
			"status": 0,
			"titel": "Beoordelingscriteria (Algemeen)"
		}],
	voortgangsrapportBeads: [
		{
			"tab": 10,
			"status": 0,
			"titel": "Project"
		},
		{
			"tab": 11,
			"status": 0,
			"titel": "BeoordelingsCriteria"
		},
		{
			"tab": 12,
			"status": 0,
			"titel": "Verantwoording"
		}],
	voortgangsrapportLoaded: {
		isLoaded: false,
		hasValidationErrors: false
	},
	settings: {
		apiRoot: '', // root to the api site, including /api
		siteRoot: '', // root to the website
		apiControllerPaths: [],
		helpdeskContactLink: "",
		fileTypes: {},
		maxAllowedContentLength: "",
		lockAllDossiers: false,
		topSportSjabloon: "",
		maxMapFeaturesToLoad: 1500,
		osmBaseLayerUrl: ""
	},
	layout: {
		pageHeaderTitle: "",
		pageHeaderSubtitle: "",
		pageHeaderIntro: "",
		activeTopNavItemId: "1",
		showTopNav: true,
		disableTopNav: false,
		showVoortgangsrapportLayout: false,
		topNavTabSettings: {
			dossierTab: { disabled: true, visible: true, urlSuffix: "" },
			projectTab: { disabled: true, visible: true, urlSuffix: "" },
			minimaleEisenTab: { disabled: true, visible: true, urlSuffix: "" },
			financieelTab: { disabled: true, visible: true, urlSuffix: "" },
			bovenLokaliteitTab: { disabled: true, visible: false, urlSuffix: "" },
			beoordelingscriteriaTab: { disabled: true, visible: false, url: "", urlSuffix: "" },
			indienenTab: { disabled: true, visible: true, urlSuffix: "" }
		},
		voortgangsrapportTopNavTabSettings: {
			projectTab: { disabled: true, visible: true, urlSuffix: "" },
			beoordelingscriteriaTab: { disabled: true, visible: false, urlSuffix: "" },
			verantwoordingTab: { disabled: true, visible: false, urlSuffix: "" },
			indienenTab: { disabled: true, visible: false, urlSuffix: "" }
		},
		disableInputComponents: false,
		showSideNav: false,
		showSideNavFinancieel: false,
		sideNavItems: [],
		sideNavPrefix: "",
		showBeads: true,
		hideAlgemeenButton: false
	},
	referentie: {
		postcodes: null,
		gemeenten: null,
		juridischeStatuten: null,
		dossierTypes: null,
		soortenInfrastructuur: [],
		soortenInfrastructuurAll: [],
		langdurigZakelijkRechtTypes: null,
		deadlinesStartWerken: null,
		stedenbouwkundigeBestemmingen: null,
		doelgroepen: null,
		btwPercentages: [],
		hoofdCategorienInvestering: [],
		typesInvestering: [],
		typeOpbrengstKostInvesteringen: [],
		algemeneStatussen: null,
		standVanZakenMER: [],
		soortenWerken: []
	}
};
